import { render, staticRenderFns } from "./TemplatesFilters.vue?vue&type=template&id=168f75d0&scoped=true"
import script from "./TemplatesFilters.vue?vue&type=script&lang=js"
export * from "./TemplatesFilters.vue?vue&type=script&lang=js"
import style0 from "./TemplatesFilters.vue?vue&type=style&index=0&id=168f75d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f75d0",
  null
  
)

export default component.exports